"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOpenInspections = instanceOfOpenInspections;
exports.OpenInspectionsFromJSON = OpenInspectionsFromJSON;
exports.OpenInspectionsFromJSONTyped = OpenInspectionsFromJSONTyped;
exports.OpenInspectionsToJSON = OpenInspectionsToJSON;
exports.OpenInspectionsToJSONTyped = OpenInspectionsToJSONTyped;
/**
 * Check if a given object implements the OpenInspections interface.
 */
function instanceOfOpenInspections(value) {
    if (!('date' in value) || value['date'] === undefined)
        return false;
    if (!('inspectionStartTime' in value) || value['inspectionStartTime'] === undefined)
        return false;
    if (!('inspectionEndTime' in value) || value['inspectionEndTime'] === undefined)
        return false;
    if (!('utcInspectionStartTime' in value) || value['utcInspectionStartTime'] === undefined)
        return false;
    if (!('utcInspectionEndTime' in value) || value['utcInspectionEndTime'] === undefined)
        return false;
    return true;
}
function OpenInspectionsFromJSON(json) {
    return OpenInspectionsFromJSONTyped(json, false);
}
function OpenInspectionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'date': json['date'],
        'inspectionStartTime': json['inspectionStartTime'],
        'inspectionEndTime': json['inspectionEndTime'],
        'utcInspectionStartTime': json['utcInspectionStartTime'],
        'utcInspectionEndTime': json['utcInspectionEndTime'],
    };
}
function OpenInspectionsToJSON(json) {
    return OpenInspectionsToJSONTyped(json, false);
}
function OpenInspectionsToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'date': value['date'],
        'inspectionStartTime': value['inspectionStartTime'],
        'inspectionEndTime': value['inspectionEndTime'],
        'utcInspectionStartTime': value['utcInspectionStartTime'],
        'utcInspectionEndTime': value['utcInspectionEndTime'],
    };
}
